import Cleave from "cleave.js/react";
import SVGIcon from "common/SVGIcon";
import { APPLICATION_STATE, PHONE_STATE, REJECTION_REASON } from "lib/constants";
import React, { useCallback, useState } from "react";

import { Button } from "common/Buttons";
import ErrorText from "common/ErrorText";
import { applicationShape, userShape } from "lib/propTypes";
import config from "js/config";
import { usePatchApplication } from "redux/applications/hooks";
import { usePatch } from "redux/fetch-hooks";
import { validatePhone } from "lib/util";

import Reschedule from "./CandidateUpdatePhoneReschedule";

const CandidateUpdatePhone = ({ application, user }) => {
    const [phone, setPhone] = useState(user.phone);
    const [phoneState, setPhoneState] = useState(user.phone_state);
    const [error, setError] = useState();
    const [patchPhone, { isLoading }] = usePatch("/api/hire/v1/auth/");
    const [patchApp] = usePatchApplication({ useHandlers: false });

    function onChange(event) {
        setPhone(event.target.value.replace(/\D/g, ""));
    }

    const onSubmit = useCallback(() => {
        if (!validatePhone(phone)) {
            setError("Please enter a valid phone number.");
            return;
        }

        patchPhone({
            data: {
                csrf_token: window.csrfToken,
                phone,
                phone_state: true,
            },
            onError: (e) => {
                setError(e.message);
            },
            onSuccess: () => {
                const isInterview = application.state === APPLICATION_STATE.INTERVIEW;
                if (phone !== user.phone && isInterview) {
                    setPhoneState(PHONE_STATE.CHANGED);
                } else {
                    setPhoneState(PHONE_STATE.VERIFIED);

                    // If they didn't change their phone number, put them back
                    // into a rejected state.
                    if (isInterview) {
                        patchApp(application.id, {
                            data: {
                                state: APPLICATION_STATE.REJECTED,
                            },
                            metadata: {
                                rejectReasons: [REJECTION_REASON.INVALID_PHONE_NUMBER],
                            },
                        });
                    }
                }
            },
        });
    }, [phone]);

    if (phoneState !== PHONE_STATE.UNVERIFIED) {
        return <Reschedule application={application} phoneState={phoneState} />;
    }

    return (
        <div className="card-container">
            <div className="card card--feedback">
                <div className="card__summary">
                    <div className="align-center">
                        <SVGIcon icon="profile" />
                        <span>{user.email}</span>
                    </div>
                </div>

                <div className="card__body">
                    <h2>Update your phone number</h2>
                    <p>
                        Please provide a number where hiring managers will be able to reach you
                        directly.
                    </p>
                </div>

                <div className="card__form">
                    <Cleave
                        placeholder="555-555-5555"
                        options={config.cleave.PHONE_CONFIG}
                        onChange={onChange}
                    />
                    <ErrorText error={error} />
                </div>
            </div>
            <div className="card-container__footer">
                <Button primary large onClick={onSubmit} loading={isLoading}>
                    Submit
                </Button>
            </div>
        </div>
    );
};

CandidateUpdatePhone.propTypes = {
    application: applicationShape.isRequired,
    user: userShape.isRequired,
};

export default CandidateUpdatePhone;
